import Button from '@creditflowresearch/uilib/Button';
import {
  usePortfolioMonitorContext,
} from '@/creditflowresearch/application/PortfolioMonitor/PortfolioMonitorContext';

import styles from './styles.module.scss';

const GetStartedButton = () => {
  const { setIsFormOpened } = usePortfolioMonitorContext();

  const openForm = () => setIsFormOpened(true);

  return (
    <Button
      dataTest="cusipPortfolioGetStartedButton"
      variant="solid"
      color="primary"
      className={ styles.getStartedButton }
      onClick={ openForm }
    >
      Get Started
    </Button>
  );
};

export default GetStartedButton;
